import React from 'react'
import "./Informations.scss"
import { PiUpload } from 'react-icons/pi'
import { Link } from 'react-router-dom'
export default function Informations() {
  return (
    <div className='p-3'>
                <div className="headerr">
        <div className="stock-filters">
          <button className="stock-filter actives">Information</button>
          <Link to="/dashboard/Client-Orders"  className='no-style-link'> <button className="stock-filter">Orders</button></Link>
                  <Link to="/dashboard/Client-Payments"  className='no-style-link'> <button className="stock-filter">Payments</button></Link>
                           <Link to="/dashboard/Client-Notices"  className='no-style-link'> <button className="stock-filter">Notices</button></Link>
                                    <Link to="/dashboard/Emarketing-products"  className='no-style-link'> <button className="stock-filter">E-marketing</button></Link>

        </div>
      
        <div className="search-wrapperr">
          <input
            type="text"
            placeholder="Search by order id"
            className="stock-search"
          />
          <i className="fa-solid fa-magnifying-glass search-icon"></i>
        </div>
      
        <div className="stock-header">
          <input type="date" placeholder="select dates" />
          <div className="stock-actions">
            <button className="stock-btn blue">Filters</button>
            <button className="stock-btn"><PiUpload/>  Export</button>
          </div>
        </div>
      </div>
      <div className='personal-info'>
        <div className=' d-flex align-items-center gap-5 '>
            <div className=' '>
<div className='image mb-4'>
    Image
</div>
<div className=' d-flex align-items-center gap-2'>
 <div style={{
                            backgroundColor:"#0ec755",
                            width:"10px",
                            height:"10px",
                            borderRadius:"50px",
                            color:"#b6bfe8"

                        }}></div>
                        <span style={{
                            color:"#b6bfe8"
                        }}>Online</span>
</div>
            </div>

<div className=' d-flex flex-column'>
<h4 style={{
    color:"black",
    marginBottom:"15px",
    fontSizeP:"20px"
}} >Osama Ali Ali</h4>
<span style={{
    color:"#858993",
    fontSize:"15px",
    marginLeft:"15px"
}}>         Osama@gmail.com</span>
<span style={
    {
          marginLeft:"15px"
    }
}>Client +</span>
</div>


        </div>

        <div className='vrt-line'></div>

<div className="personal-info-box">
  <p className="section-title">Personal Information</p>
  <div className="info-list">
    <div className="info-item">
      <span className="label">Contact Number</span>
      <span className="value">003737737</span>
    </div>
    <div className="info-item">
      <span className="label">Gender</span>
      <span className="value">Male</span>
    </div>
    <div className="info-item">
      <span className="label">Date of Birth</span>
      <span className="value">1 Jan, 1985</span>
    </div>
    <div className="info-item">
      <span className="label">Country</span>
      <span className="value">Morocco</span>
    </div>
    <div className="info-item">
      <span className="label">Member Since</span>
      <span className="value">3 March, 2023</span>
    </div>
  </div>
</div>
        <div className='vrt-line'></div>

<div className="personal-info-box d-flex  flex-column justify-content-around">
    <div>
  <p className="section-title">Performance information</p>
<div>
<span  style={{
    color:"#1d4ed8",
    fontWeight:'bold',
     fontSize:"10px"
}}>Wallt</span>   <span style={{
    color:"#1d4ed8",
    fontWeight:'bold',
    fontSize:"18px"
}}>EGP35.00</span>
</div>

    </div>


<div className=' d-flex gap-5'>
    <div className=' d-flex  flex-column'>
        <span style={{
            color:"#01a9fc", 
             fontWeight:'bold'
        }}>150</span>
        <span style={{
            color:"#7f838c", 
            
        }}>Total Orders</span>
    </div>
       <div className=' d-flex  flex-column'>
        <span style={{
            color:"#28c76f", 
             fontWeight:'bold'
        }}>50</span>
        <span style={{
            color:"#7f838c", 
        
        }}>Balance</span>
    </div>
       <div className=' d-flex  flex-column'>
        <span style={{
            color:"#e71d36", 
             fontWeight:'bold'
        }}>350</span>
        <span style={{
            color:"#7f838c", 
             
        }}>Total Points</span>
    </div>
</div>
</div>

      </div>


      <div className=' mt-4'>
        <table className=' table'>
 

           <tbody>
            <tr className=' p-3'>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                      padding:"15px"
                }}>USER NAME</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>PERFORMANCE</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>NOTFICATIONS</td>
                 <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>EVALUATION</td>
                        <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>ACCOUNT STATUS</td>
            </tr>
              <tr>
                <td style={{
                   
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px",
                         color:"#8b909a"
                }}>osama</td>
                <td style={{
                   
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>acceptable</td>
                <td style={{
                    textAlign:"center",
                     fontSize:"14px",
                       padding:"15px"
                }}>17</td>
                 <td style={{
                   
                     fontSize:"14px", textAlign:"center",
                       padding:"15px"
                }}>6.5</td>
                 <td style={{
                   
                     fontSize:"14px", textAlign:"center",
                       padding:"15px"
                }}>
                <span style={{
                        border:  " 1px solid #ed9100",
                        backgroundColor:"#fff9f2",
                        padding:" 2px 15px",
                        fontWeight:"bold",
    color: "#df6641",
  borderRadius: "5px"
                }}>
inactive
                </span>
                </td>
            </tr>
              <tr >
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                     textAlign:"center",
                       padding:"15px"
                }}>LAST ORDER</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>LAST SEEN</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>LATEST NOTICE</td>
                   <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>LAST PAYMENT</td>
            
            </tr>
          <tr className="no-border">
  <td className="no-border-cell">14 Jan, 2024</td>
  <td className="no-border-cell">2 min ago</td>
  <td className="no-border-cell">14 Jan, 2024</td>
  <td className="no-border-cell">14 Jan, 2024</td>
</tr>

           </tbody>
        </table>

     
      </div>



      
      <div className=' mt-4'>
        <table className=' table'>
       <thead style={{ backgroundColor: "#f2f4f6" ,
        borderBottom:"1px solid #5f6c72"
       }}>
  <tr>
    <th
      colSpan="100%"
      style={{
        backgroundColor: "#f2f4f6",
        textAlign: "center", 
        padding: "12px 16px",
        fontSize: "16px",
        fontWeight: "600",
        color: "#2b2f32",
        borderBottom: "2px solid #d1d5db"
      }}
    >
      Banking Information
    </th>
  </tr>
</thead>

           <tbody>
            <tr className=' p-3'>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                      padding:"15px"
                }}>RECEING METHOD</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>BANK NAME</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>ACCOUNT NUMBER</td>
                 <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>PHONE NUMBER</td>
                        <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>EMAIL</td>
            </tr>
              <tr>
                <td style={{
                   
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>mobile transfer</td>
                <td style={{
                   
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>Vodavone ach</td>
                <td style={{
                    textAlign:"center",
                     fontSize:"14px",
                       padding:"15px"
                }}>01126849457</td>
                 <td style={{
                   
                     fontSize:"14px", textAlign:"center",
                       padding:"15px"
                }}>PHONE NUMBER</td>
                 <td style={{
                   
                     fontSize:"14px", textAlign:"center",
                       padding:"15px"
                }}>osama@gmail.com</td>
            </tr>
              <tr >
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                     textAlign:"center",
                       padding:"15px"
                }}>Total operations</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>Total transfers</td>
                <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>Last transfer</td>
                   <td style={{
                     color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>Date</td>
                 <td style={{
                    //  color:"#8b909a",
                     fontSize:"14px",
                      textAlign:"center",
                        padding:"15px"
                }}>...</td>
            </tr>
          <tr className="no-border">
  <td className="no-border-cell">14</td>
  <td className="no-border-cell">14</td>
  <td className="no-border-cell">$15</td>
  <td className="no-border-cell">$15</td>
  <td className="no-border-cell">14 Jan, 2024</td>
</tr>

           </tbody>
        </table>

        <div className=' d-flex more-info  align-items-center  justify-content-end'>
            <span style={{
                color:"#8b909a"
            }}>Payable</span>
            <span style={{
                color:"#e71d36"
            }}>$35.00</span>
        </div>
      </div>
    </div>
  )
}
